export default "__VITE_ASSET__Dv31DRp3__"